import { render } from "./BottomNav.vue?vue&type=template&id=0a0f41c8"
const script = {}

import "./BottomNav.vue?vue&type=style&index=0&id=0a0f41c8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__